import { AbstractControl } from '@angular/forms';
import * as dayjs from 'dayjs';

export function dateValidator(control: AbstractControl) {
    let earliest  = dayjs("1900-01-01");
    let future = dayjs().add(1, 'y');

    // invalid if date does exist, does not have valid format and not within the range
    if( control.value != null  && isNaN(dayjs(control.value).year())) {
        return { "invalidDate": true };
    }
    if ( control.value != null && (!dayjs(control.value).isValid() || 
        !(dayjs(control.value).isAfter(earliest) &&  dayjs(control.value).isBefore(future)))) {
        return { "invalidDate": true };
    }
    if(dayjs(control.value).year() < 1900) {
        return { "invalidDate": true };
    }
    return null;
}
